import {RatingStars} from '@frontend/components/RatingStars'
import {Card} from 'swayok-react-mdb-ui-kit/components/Card/Card'
import {CardBody} from 'swayok-react-mdb-ui-kit/components/Card/CardBody'
import {UserAvatar} from '../../../../components/UserAvatar'
import {useUserData} from '../../../../hooks'
import {CabinetMoneyEarnedCard} from './CabinetMoneyEarnedCard'
import {CabinetUserReviewsButton} from './CabinetUserReviewsButton'

// Информация о профиле пользователя в ЛК.
export function CabinetSideMenuUserInfo() {

    const user = useUserData()!

    if (!user) {
        return null
    }

    return (
        <Card id="cabinet-side-menu-user-info">
            <CardBody>
                <div className="d-flex gap-4 flex-row align-items-center">
                    <UserAvatar userName={user.fullName} />
                    <div className="d-flex flex-column align-items-stretch">
                        <div className="fw-500">
                            {user.fullName}
                        </div>
                        <div
                            className="flex-container-row gap-2 my-1"
                            title={String(user.rating)}
                        >
                            {/*
                            <div className="fw-500">
                                {user.rating}
                            </div>
                            */}
                            <RatingStars
                                rating={user.rating}
                                starSize={20}
                                className="gap-0"
                            />
                        </div>
                        <CabinetUserReviewsButton />
                    </div>
                </div>
                <CabinetMoneyEarnedCard className="mt-3" />
            </CardBody>
        </Card>
    )
}
